{
  "deleteAdminAccess": "Delete Admin Access",
  "addAdmin": "Add Admin",
  "inviteAdmin": "Invite Admin",
  "invitesSent": "{{success}} invite sent",
  "invitesAlreadyExist": "{{already_exist}} already exist",
  "invitedEmails": "Invited ({{count}})",
  "existingEmails": "Already exist ({{count}})",
  "okay": "Okay",
  "sureWantDeleteAdminDistrict": "Are you sure you want to delete {{name}} as an admin from your district?",
  "sendInvite": "Send Invite",
  "phoneNumber": "Phone Number",
  "inviteAdmins": "Invite Admins",
  "youCanInviteOtherPeople": "You can invite other people in your district to be admins in Campus Guardian Angel. If you want to do this now, add their emails below. You can also do this later.",
  "adminsForDistrict": "{{count}} Campus Guardian Angel admins for {{district}}"
}
